"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Modal = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactTransitionGroup = require("react-transition-group");
var _icon = _interopRequireDefault(require("../icon"));
var _touch = _interopRequireDefault(require("../utilities/touch"));
var _modalModule = _interopRequireDefault(require("./modal.module.scss"));
require("../style/animations.scss");
var _utilities = require("../utilities");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Modal = exports.Modal = /*#__PURE__*/function (_Component) {
  function Modal() {
    var _this;
    _classCallCheck(this, Modal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Modal, [].concat(args));
    _defineProperty(_this, "touch", new _touch["default"]());
    _defineProperty(_this, "lightBoxRef", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_this, "lightBoxInnerRef", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_this, "lightBoxContentRef", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_this, "document", document);
    _defineProperty(_this, "backgroundClose", function (event) {
      if (_this.props.canClose) {
        if (_this.lightBoxContentRef && !_this.lightBoxContentRef.current.contains(event.target)) {
          _this.props.onClose && _this.props.onClose();
        }
      }
    });
    _defineProperty(_this, "getContentClass", function () {
      return "".concat(_modalModule["default"].content, " ").concat(_this.props.type && _modalModule["default"][_this.props.type]);
    });
    _defineProperty(_this, "getCloseClass", function () {
      return "".concat(_modalModule["default"].lightBoxCloseSmall, " ").concat(_this.touch.isTouchDevice() && _modalModule["default"].mobile);
    });
    _defineProperty(_this, "handleEnter", function () {
      /** Show the lightbox when starting the show transition */
      _this.lightBoxRef.current.style.display = "block";
      _this.document.body.style.overflow = "hidden";
    });
    _defineProperty(_this, "handleExited", function () {
      /** Hide the lightbox when the hide transition has ended */
      _this.lightBoxRef.current.style.display = "none";
      _this.document.body.style.overflow = "auto";
    });
    return _this;
  }
  _inherits(Modal, _Component);
  return _createClass(Modal, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.CSSTransition, {
        key: "light-box",
        nodeRef: this.lightBoxRef,
        "in": this.props.visible,
        timeout: 200,
        appear: true,
        classNames: "transition-fade",
        onClick: this.backgroundClose,
        onEnter: this.handleEnter,
        onExited: this.handleExited
      }, /*#__PURE__*/_react["default"].createElement("div", _extends({
        ref: this.lightBoxRef,
        className: _modalModule["default"].lightBoxContainer,
        "data-testid": "light-box"
      }, _utilities.utilities.getDataAttributes(this.props), {
        "data-visible": this.props.visible,
        tabIndex: "-1"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _modalModule["default"].lightBoxBg
      }), /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.CSSTransition, {
        key: "".concat(name, "Scale"),
        nodeRef: this.lightBoxInnerRef,
        "in": this.props.visible,
        timeout: 200,
        appear: true,
        classNames: "transition-fade-scale"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.lightBoxInnerRef,
        className: _modalModule["default"].lightBoxInner
      }, /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.lightBoxContentRef,
        className: _modalModule["default"].lightBox
      }, this.props.canClose && /*#__PURE__*/_react["default"].createElement("button", {
        "data-testid": "light-box-close",
        className: this.getCloseClass(),
        title: "Close",
        onClick: function onClick() {
          return _this2.props.onClose();
        }
      }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
        type: "Close"
      })), this.props.title && /*#__PURE__*/_react["default"].createElement("h2", {
        "data-testid": "light-box-title"
      }, this.props.title), this.props.subHeading && /*#__PURE__*/_react["default"].createElement("h3", {
        "data-testid": "light-box-sub-heading"
      }, this.props.subHeading), /*#__PURE__*/_react["default"].createElement("div", {
        "data-testid": "light-box-content",
        className: this.getContentClass()
      }, this.props.children))))));
    }
  }]);
}(_react.Component);
Modal.propTypes = {
  visible: _propTypes["default"].bool,
  canClose: _propTypes["default"].bool,
  title: _propTypes["default"].string,
  subHeading: _propTypes["default"].string,
  type: _propTypes["default"].oneOf(["null", "error", "warning"]),
  onClose: _propTypes["default"].func
};
Modal.defaultProps = {
  visible: false,
  canClose: true,
  title: null,
  subHeading: "Header",
  type: null,
  onClose: null
};
var _default = exports["default"] = Modal;